export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/80821a7127edf6626cb7d3e082946c04/7c920e29a64605fcdd1dd8f8050bedba.jpeg"
                alt="ICMI Logo - Instituto de Capacitação Ministerial"
                className="h-20 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Instituto de Capacitação Ministerial - Formando líderes cristãos com excelência desde 2017.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-award-line text-white text-xl"></i>
              </div>
              <div>
                <div className="font-bold text-lg">300+</div>
                <div className="text-xs text-gray-400">Alunos Formados</div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Navegação</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('sobre')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  Sobre o ICMI
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('cursos')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  Nossos Cursos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('mentorias')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  Mentorias
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contato')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Cursos Principais</h3>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Teologia</li>
              <li className="text-gray-400 text-sm">Capelania Cristã</li>
              <li className="text-gray-400 text-sm">Liderança</li>
              <li className="text-gray-400 text-sm">Pregação Expositiva</li>
              <li className="text-gray-400 text-sm">Aconselhamento Pastoral</li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contato</h3>
            <div className="space-y-4">
              <a
                href="https://wa.me/5567992870208"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span className="text-sm">(67) 99287-0208</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <i className="ri-map-pin-line text-xl"></i>
                <span className="text-sm">Mato Grosso do Sul, Brasil</span>
              </div>
            </div>

            <div className="mt-6">
              <a
                href="https://wa.me/5567992870208"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                Fale Conosco
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2024 ICMI - Instituto de Capacitação Ministerial. Todos os direitos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
